<template>
  <section class="mini-kasko-order__card mini-kasko-order__card--concluded">
    <div class="mini-kasko-order__concluded">
      <div class="mini-kasko-order__concluded-hero">
        <div class="mini-kasko-order__concluded-icon">✓</div>
        <div>
          <h2 class="mini-kasko-order__concluded-title">Поліс оформлено</h2>
          <p class="mini-kasko-order__subtitle">
            Замовлення завершено. Документ доступний для перегляду та завантаження.
          </p>
        </div>
      </div>

      <div class="mini-kasko-order__summary-grid">
        <div class="mini-kasko-order__summary-item">
          <span class="mini-kasko-order__summary-label">Номер поліса</span>
          <span class="mini-kasko-order__summary-value">{{ policyNumber || 'Не вказано' }}</span>
        </div>
        <div class="mini-kasko-order__summary-item">
          <span class="mini-kasko-order__summary-label">Період дії</span>
          <span class="mini-kasko-order__summary-value">{{ policyPeriod }}</span>
        </div>
        <div class="mini-kasko-order__summary-item">
          <span class="mini-kasko-order__summary-label">Страхувальник</span>
          <span class="mini-kasko-order__summary-value">{{ insurantName }}</span>
        </div>
        <div class="mini-kasko-order__summary-item">
          <span class="mini-kasko-order__summary-label">Авто</span>
          <span class="mini-kasko-order__summary-value">{{ vehicleLabel }}</span>
        </div>
      </div>

      <div class="mini-kasko-order__concluded-section">
        <h3 class="mini-kasko-order__group-title">Параметри поліса</h3>
        <div class="mini-kasko-order__summary-grid">
          <div class="mini-kasko-order__summary-item">
            <span class="mini-kasko-order__summary-label">Дата початку</span>
            <span class="mini-kasko-order__summary-value">{{ formatDisplayDate(form.dates.startDate) }}</span>
          </div>
          <div class="mini-kasko-order__summary-item">
            <span class="mini-kasko-order__summary-label">Дата завершення</span>
            <span class="mini-kasko-order__summary-value">{{ policyEndDate }}</span>
          </div>
        </div>
      </div>

      <div class="mini-kasko-order__concluded-section">
        <h3 class="mini-kasko-order__group-title">Страхувальник</h3>
        <div class="mini-kasko-order__summary-grid">
          <div class="mini-kasko-order__summary-item">
            <span class="mini-kasko-order__summary-label">ІПН / код</span>
            <span class="mini-kasko-order__summary-value">{{ displayValue(form.customer.code) }}</span>
          </div>
          <div class="mini-kasko-order__summary-item">
            <span class="mini-kasko-order__summary-label">Прізвище</span>
            <span class="mini-kasko-order__summary-value">{{ displayValue(form.customer.surname) }}</span>
          </div>
          <div class="mini-kasko-order__summary-item">
            <span class="mini-kasko-order__summary-label">Ім'я</span>
            <span class="mini-kasko-order__summary-value">{{ displayValue(form.customer.name) }}</span>
          </div>
          <div class="mini-kasko-order__summary-item">
            <span class="mini-kasko-order__summary-label">По батькові</span>
            <span class="mini-kasko-order__summary-value">{{ displayValue(form.customer.middle_name) }}</span>
          </div>
          <div class="mini-kasko-order__summary-item">
            <span class="mini-kasko-order__summary-label">Телефон</span>
            <span class="mini-kasko-order__summary-value">{{ displayValue(form.customer.phone) }}</span>
          </div>
          <div class="mini-kasko-order__summary-item">
            <span class="mini-kasko-order__summary-label">Email</span>
            <span class="mini-kasko-order__summary-value">{{ displayValue(form.customer.email) }}</span>
          </div>
          <div class="mini-kasko-order__summary-item">
            <span class="mini-kasko-order__summary-label">Дата народження</span>
            <span class="mini-kasko-order__summary-value">{{ formatDisplayDate(form.customer.born_date) }}</span>
          </div>
          <div class="mini-kasko-order__summary-item">
            <span class="mini-kasko-order__summary-label">Паспорт</span>
            <span class="mini-kasko-order__summary-value">{{ displayValue(form.customer.document_number) }}</span>
          </div>
          <div class="mini-kasko-order__summary-item">
            <span class="mini-kasko-order__summary-label">Дата видачі паспорта</span>
            <span class="mini-kasko-order__summary-value">{{ formatDisplayDate(form.customer.document_issued_date) }}</span>
          </div>
          <div class="mini-kasko-order__summary-item">
            <span class="mini-kasko-order__summary-label">Ким видано паспорт</span>
            <span class="mini-kasko-order__summary-value">{{ displayValue(form.customer.document_issued_by) }}</span>
          </div>
          <div class="mini-kasko-order__summary-item">
            <span class="mini-kasko-order__summary-label">Адреса</span>
            <span class="mini-kasko-order__summary-value">{{ displayValue(customerAddressLabel) }}</span>
          </div>
        </div>
      </div>

      <div class="mini-kasko-order__concluded-section">
        <h3 class="mini-kasko-order__group-title">Автомобіль</h3>
        <div class="mini-kasko-order__summary-grid">
          <div class="mini-kasko-order__summary-item">
            <span class="mini-kasko-order__summary-label">Держномер</span>
            <span class="mini-kasko-order__summary-value">{{ displayValue(form.car.reg_num) }}</span>
          </div>
          <div class="mini-kasko-order__summary-item">
            <span class="mini-kasko-order__summary-label">VIN</span>
            <span class="mini-kasko-order__summary-value">{{ displayValue(form.car.vin) }}</span>
          </div>
          <div class="mini-kasko-order__summary-item">
            <span class="mini-kasko-order__summary-label">Рік випуску</span>
            <span class="mini-kasko-order__summary-value">{{ displayValue(form.car.year) }}</span>
          </div>
          <div class="mini-kasko-order__summary-item">
            <span class="mini-kasko-order__summary-label">Марка</span>
            <span class="mini-kasko-order__summary-value">{{ displayValue(form.car.mark_name) }}</span>
          </div>
          <div class="mini-kasko-order__summary-item">
            <span class="mini-kasko-order__summary-label">Модель</span>
            <span class="mini-kasko-order__summary-value">{{ displayValue(form.car.model_name) }}</span>
          </div>
          <div class="mini-kasko-order__summary-item">
            <span class="mini-kasko-order__summary-label">Категорія</span>
            <span class="mini-kasko-order__summary-value">{{ displayValue(form.car.category) }}</span>
          </div>
          <div class="mini-kasko-order__summary-item">
            <span class="mini-kasko-order__summary-label">Тип авто</span>
            <span class="mini-kasko-order__summary-value">{{ displayValue(selectedCarTypeLabel) }}</span>
          </div>
          <div class="mini-kasko-order__summary-item">
            <span class="mini-kasko-order__summary-label">Місце реєстрації</span>
            <span class="mini-kasko-order__summary-value">{{ displayValue(form.car.registration_city_name) }}</span>
          </div>
          <div class="mini-kasko-order__summary-item">
            <span class="mini-kasko-order__summary-label">Таксі</span>
            <span class="mini-kasko-order__summary-value">{{ Number(form.car.is_taxi) ? 'Так' : 'Ні' }}</span>
          </div>
        </div>
      </div>

      <div class="mini-kasko-order__actions">
        <button type="button" class="mini-kasko-order__action mini-kasko-order__action--secondary"
                @click="$emit('go-to-offers')">
          До пропозицій
        </button>
        <button type="button" class="mini-kasko-order__action mini-kasko-order__action--primary"
                @click="$emit('open-contract')">
          Відкрити поліс
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import moment from 'moment';

export default {
  name: 'MiniKaskoOrderConcluded',
  props: {
    form: Object,
    policyNumber: String,
    policyPeriod: String,
    policyEndDate: String,
    insurantName: String,
    vehicleLabel: String,
    selectedCarTypeLabel: String,
    customerAddressLabel: String,
    isProcessing: Boolean,
  },
  emits: ['go-to-offers', 'open-contract'],
  methods: {
    displayValue(value) {
      return value === null || value === undefined || value === '' ? 'Не вказано' : String(value);
    },
    formatDisplayDate(value) {
      if (!value) {
        return 'Не вказано';
      }

      const parsed = moment(value, ['YYYY-MM-DD', 'DD.MM.YYYY'], true);

      return parsed.isValid() ? parsed.format('DD.MM.YYYY') : 'Не вказано';
    },
  },
};
</script>

<style lang="scss" scoped>
.mini-kasko-order {
  &__card {
    background: #fff;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06), 0 1px 2px rgba(15, 23, 42, 0.04);

    &--concluded {
      background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
    }
  }

  &__concluded {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  &__concluded-hero {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  &__concluded-icon {
    width: 48px;
    height: 48px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #f0fdf4;
    color: #15803d;
    font-size: 24px;
    font-weight: 700;
  }

  &__concluded-title {
    font-size: 24px;
    line-height: 30px;
    font-weight: 600;
    margin: 0 0 6px;
  }

  &__concluded-section {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  &__summary-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
  }

  &__summary-item {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 14px 16px;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
  }

  &__summary-label {
    color: #71717a;
    font-size: 12px;
    line-height: 16px;
  }

  &__summary-value {
    color: #09090b;
    font-size: 15px;
    line-height: 22px;
    font-weight: 600;
  }

  &__group-title {
    font-size: 18px;
    line-height: 24px;
    font-weight: 600;
  }

  &__subtitle {
    color: #52525b;
    font-size: 14px;
    line-height: 20px;
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 24px;
  }

  &__action {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 190px;
    min-height: 48px;
    padding: 0 18px;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 500;
    text-align: center;
    cursor: pointer;
    transition: background-color 0.2s ease, border-color 0.2s ease, opacity 0.2s ease;

    &:disabled {
      opacity: 0.6;
      cursor: default;
    }

    &--secondary {
      background: #fff;
      color: #0a77ff;
      border: 1px solid #cbd5e1;
    }

    &--primary {
      background: #fb923c;
      color: #fff;
      border: 0;
    }
  }

  @media (max-width: 960px) {
    &__summary-grid {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 640px) {
    &__card {
      padding: 16px;
    }

    &__actions {
      flex-direction: column;
      align-items: stretch;
    }

    &__action {
      width: 100%;
    }
  }
}
</style>
